export enum batuActionTypes {
  SET_BATU = 'set_batu',
  RESET_BATU = 'reset_batu',
}
